import * as React from "react";
import { cn } from "@/lib/utils";

export interface BadgeNewProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  variant?: "pink" | "blue" | "green" | "yellow" | "white" | "custom";
  animation?: "bounce" | "pulse" | "glow" | "shimmer" | "none";
  children: React.ReactNode;
  className?: string;
  badgeClassName?: string;
}

const colorMap: Record<string, string> = {
  pink: "bg-pink-500 text-white shadow-pink-400/50",
  blue: "bg-blue-500 text-white shadow-blue-400/50",
  green: "bg-green-500 text-white shadow-green-400/50",
  yellow: "bg-yellow-400 text-background-300 shadow-yellow-200/40",
  white: "bg-foreground text-pink-500 shadow-md",
  custom: "",
};

const animationMap: Record<string, string> = {
  bounce: "badge-bounce",
  pulse: "badge-pulse",
  glow: "badge-glow",
  shimmer: "badge-shimmer",
  none: "",
};

const BadgeNew = React.forwardRef<HTMLDivElement, BadgeNewProps>(
  (
    {
      label = "NEW!",
      variant = "pink",
      animation = "bounce",
      children,
      className,
      badgeClassName,
      ...props
    },
    ref
  ) => (
    <div
      ref={ref}
      className={cn("relative inline-block align-middle", className)}
      {...props}
    >
      {/* Badge in top-right corner, slightly left-shifted */}
      <span
        className={cn(
          "absolute -top-4 -right-5 -translate-x-1/4 z-10 select-none",
          "rounded-full px-2 py-[2px] text-xs font-bold rotate-[11deg] shadow-lg",
          "pointer-events-none",
          colorMap[variant],
          animationMap[animation],
          badgeClassName
        )}
      >
        {label}
      </span>
      {children}
    </div>
  )
);

BadgeNew.displayName = "BadgeNew";

export { BadgeNew };
